export const PRIZE_TYPE_SIMPLE = 1;
export const PRIZE_TYPE_DOWNLOAD = 2;
export const PRIZE_TYPE_LINK = 3;